import { Title } from "@/components/lib/Title";
import { OrderType } from "@/types/OrderType";
import { setDateTime } from "@/utils/Functions";
import { Params } from "react-router-dom";

export const HeaderOrderDetail = ({isDesktop, param, data }: {isDesktop: boolean, param: Readonly<Params<string>>, data: OrderType | undefined}) => (
    <>
      {isDesktop ? (
        <>
          <Title name={'Détail de la livraison #' + param.id_order} />
          <span>Créer le {data?.createdAt && setDateTime(data?.createdAt)}</span>
        </>
      ) : (
        <>
          <div>#{ param.id_order}</div>
          <span className='font-65'>{data?.createdAt && setDateTime(data?.createdAt)}</span>
        </>
      )}
    </>
  )